import React, { useState, useEffect } from "react";
import {
  ADD_ACTIVITY,
  getApiBaseUrl,
  UPDATE_ASSET_TYPE,
  LOGIN,
} from "../../Config/Config";
import PropTypes from "prop-types";
import { Spin } from "antd";
import Swal from "sweetalert2";

const EditFilterType = ({ selectedFilterType }) => {
  const user = JSON.parse(sessionStorage.getItem("user") || "{}");
  const [formData, setFormData] = useState({
    id: "",
    AssetType: "",
    Note: "",
    Updatedby: user?.UserID || "",
  });
  const [loading, setLoading] = useState(false);
  const [askPassword, setAskPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [authLoading, setAuthLoading] = useState(false);
  const [error, setError] = useState("");
  const [changes, setChanges] = useState({});

  useEffect(() => {
    if (selectedFilterType) {
      setFormData({
        id: selectedFilterType?.Id || "",
        AssetType: selectedFilterType?.AssetType || "",
        Note: selectedFilterType?.Note || "",
        Updatedby: user?.UserID || "",
      });
      setChanges({}); // reset changes when a new filter is selected
    }
  }, [selectedFilterType]);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prev) => ({ ...prev, [name]: value }));
  //   setError("");
  // };

  const fieldNameMap = {
    AssetType: "FilterType",
    Note: "Description",
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      const newForm = { ...prev, [name]: value };
      const originalValue = selectedFilterType?.[name] || "";

      const mappedName = fieldNameMap[name] || name; // convert to FilterType/Description

      if (originalValue !== value) {
        setChanges((prevChanges) => ({
          ...prevChanges,
          [`Old${mappedName}`]: originalValue,
          [`New${mappedName}`]: value,
        }));
      } else {
        setChanges((prevChanges) => {
          const updated = { ...prevChanges };
          delete updated[`Old${mappedName}`];
          delete updated[`New${mappedName}`];
          return updated;
        });
      }
      return newForm;
    });
  };
  console.log(changes, "edit changes");
  const handleAuth = async () => {
    if (!password) {
      setError("Please enter your password.");
      return;
    }

    setAuthLoading(true);
    setError("");

    try {
      if (!user?.UserName) {
        throw new Error("User name not found in session data.");
      }

      const payload = {
        username: user.UserName,
        password,
      };

      const res = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data.status) {
        setAskPassword(false);
        setPassword("");
        await performUpdate();
      } else {
        throw new Error(
          data.Message || "Invalid credentials. Please try again."
        );
      }
    } catch (err) {
      setError(err.message || "Unable to authenticate. Please try again.");
    } finally {
      setAuthLoading(false);
    }
  };

  const performUpdate = async () => {
    const logActivity = async (isSuccess, notes) => {
      try {
        await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ActivityType: 1,
            PerformedBy: user?.UserID,
            PerformedOn: new Date()
              .toISOString()
              .slice(0, 19)
              .replace("T", " "),
            Notes: notes,
            Location: "updateBlock",
            IsSucces: isSuccess ? 1 : 0,
          }),
        });
      } catch (err) {
        console.error("Failed to log activity:", err);
      }
    };

    const payload = {
      id: formData.id,
      AssetType: formData.AssetType,
      Note: formData.Note,
      Updatedby: user?.UserID,
    };

    try {
      setLoading(true);

      const response = await fetch(`${getApiBaseUrl()}${UPDATE_ASSET_TYPE}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      const status = result?.ResultData?.[0]?.Status;
      const message = "Filter Type updated successfully.";
      const finalNote = Object.entries(changes)
        .map(([key, value]) => `${key}: ${value}`)
        .join(", ");

      if (response.ok && status === "Success") {
        await logActivity(
          true,
          `Filter Type ${finalNote} updated successfully`
        );
        Swal.fire({ icon: "success", title: "Success", text: message }).then(
          () => {
            window.location.reload();
          }
        );
      } else {
        await logActivity(
          false,
          `Filter Type ${formData.AssetType} update failed`
        );
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: "Filter Type update failed",
        });
      }
    } catch (error) {
      console.error("Error updating Filter type:", error);
      await logActivity(
        false,
        `Filter Type ${formData.AssetType} update failed: ${error.message}`
      );
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to connect to server.",
      });
    } finally {
      setLoading(false);
      setAskPassword(false);
      setPassword("");
      setError("");
    }
  };

  const handleUpdateAssetType = async (e) => {
    e.preventDefault();

    if (!formData.AssetType) {
      setError("Please fill in the Filter Type field.");
      Swal.fire({
        icon: "warning",
        title: "Validation Error",
        text: "Please fill in the Filter Type field.",
      });
      return;
    }

    if (!user?.UserID) {
      setError("Invalid user data. Please log in again.");
      Swal.fire({
        icon: "error",
        title: "User Data Error",
        text: "Invalid user data. Please log in again.",
      });
      return;
    }

    setAskPassword(true);
  };

  const clearFormData = () => {
    setFormData({
      id: "",
      AssetType: "",
      Note: "",
      Updatedby: user?.UserID || "",
    });
    setAskPassword(false);
    setPassword("");
    setError("");
  };

  useEffect(() => {
    const offcanvas = document.getElementById("EditAssetTypeOffcanvas");
    if (offcanvas) {
      const handleClose = () => {
        clearFormData();
      };
      offcanvas.addEventListener("hidden.bs.offcanvas", handleClose);
      return () => {
        offcanvas.removeEventListener("hidden.bs.offcanvas", handleClose);
      };
    }
  }, [user]);

  return (
    <div>
      {(loading || authLoading) && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div
        className="offcanvas offcanvas-end"
        tabIndex="-1"
        id="EditAssetTypeOffcanvas"
        aria-labelledby="EditAssetTypeOffcanvasLabel"
      >
        <form onSubmit={handleUpdateAssetType}>
          <div className="offcanvas-header">
            <h5 id="EditAssetTypeOffcanvasLabel">Edit Filter Type</h5>
            <div className="d-flex align-items-center ms-auto">
              <button
                type="submit"
                className="btn btn-sm btn-outline-success me-2"
                title="Save"
              >
                <i className="fa fa-check fs-4"></i>
              </button>
              <button
                type="button"
                className="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
          </div>
          <div className="offcanvas-body">
            <div className="mb-3">
              <label htmlFor="assetType" className="form-label">
                Filter Type
              </label>
              <span className="text-danger ms-1">*</span>
              <input
                type="text"
                className="form-control"
                id="assetType"
                name="AssetType"
                value={formData?.AssetType}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="note" className="form-label">
                Description
              </label>
              <textarea
                className="form-control"
                id="note"
                name="Note"
                rows="3"
                value={formData.Note || ""}
                onChange={handleChange}
              ></textarea>
            </div>
            {askPassword && (
              <div className="mt-2">
                <div className="mb-3 w-lg-75 m-auto">
                  <label className="form-label">
                    Confirm Password <span className="text-danger"> *</span>
                  </label>
                  <div className="pass-group">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      className="pass-input form-control"
                      value={password}
                      onChange={(e) => {
                        setPassword(e.target.value);
                        setError("");
                      }}
                      onCopy={(e) => e.preventDefault()}
                      onPaste={(e) => e.preventDefault()}
                      onCut={(e) => e.preventDefault()}
                      placeholder="Enter Password"
                    />
                    <span
                      className={`ti toggle-password ${
                        showPassword ? "ti-eye" : "ti-eye-off"
                      }`}
                      onClick={() => setShowPassword(!showPassword)}
                    ></span>
                  </div>
                </div>
                <button
                  type="button"
                  className="btn btn-primary btn-sm me-2"
                  onClick={handleAuth}
                  disabled={authLoading || !password}
                >
                  {authLoading ? "Verifying..." : "Confirm"}
                </button>
                <button
                  type="button"
                  className="btn btn-secondary btn-sm"
                  onClick={() => {
                    setAskPassword(false);
                    setPassword("");
                    setError("");
                  }}
                >
                  Cancel
                </button>
              </div>
            )}
            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

EditFilterType.propTypes = {
  selectedFilterType: PropTypes.shape({
    Id: PropTypes.number,
    AssetType: PropTypes.string,
    Note: PropTypes.string,
  }),
};

export default EditFilterType;
